module.exports = __webpack_public_path__ + "fontello.528503f78b8f24a07fb8.svg";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/font/fontello.svg?3640046
// module id = ../../../../../src/assets/font/fontello.svg?3640046
// module chunks = styles